import { useIntl } from 'react-intl'
import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { DndContext } from '@dnd-kit/core'
import TableComponent from '../../../../../../components/stories/organisms/table'
import TableToolbar from '../../../../../../components/stories/organisms/table/components/toolbar'
import {
  TableProjectsContainer,
  ProjectMenuTableContainer,
  ProjectMenuTableScrollContainer
} from '../../../../styled-component'
import ShowInactiveProjectSwitch from '../../../show-inactive-projects-switch'
import CompanyProjectsTableBody from './components/company-projects-table-body'
import CompanyProjectsTableContent from './components/company-projects-table-content'
import CompanyProjectsTableEditMenu from './components/company-projects-table-edit-menu'
import CompanyProjectsTablePagination from './components/company-projects-table-pagination'
import { useCompanyProjectsTable } from './hooks/use-company-projects-table'

const CompanyProjectsList = () => {
  const { formatMessage } = useIntl()
  const history = useHistory()

  const {
    childrenByFolderId,
    clearRowSelection,
    dnd,
    folderChildrenStateById,
    isError,
    pagination,
    pageSize,
    rowSelection,
    rowsById,
    search,
    selectedItems,
    setPageSize,
    setSearch,
    setShowInactive,
    showInactive,
    table,
    userPermissions
  } = useCompanyProjectsTable({ formatMessage })

  const canCreateProjects = userPermissions.includes('CreateProjects')

  const handleOpenCreateProjectModal = useCallback(() => {
    history.push('/project/new')
  }, [history])

  return (
    <TableProjectsContainer>
      <ProjectMenuTableContainer>
        <TableComponent.Root>
          <TableToolbar.Root>
            <TableToolbar.LeftContainer>
              <TableToolbar.Search
                value={search}
                onChangeSearch={setSearch}
                defaultDesktopVariantOpen={!!search}
              />
              <ShowInactiveProjectSwitch
                checked={showInactive}
                onCheckedChange={setShowInactive}
              />
            </TableToolbar.LeftContainer>
            <TableToolbar.RightContainer>
              <TableToolbar.PageSize
                onChangePageSize={setPageSize}
                pageSize={pageSize}
              />
              <CompanyProjectsTableEditMenu
                formatMessage={formatMessage}
                onBatchComplete={clearRowSelection}
                selectedItems={selectedItems}
                userPermissions={userPermissions}
              />
            </TableToolbar.RightContainer>
          </TableToolbar.Root>

          <ProjectMenuTableScrollContainer>
            <DndContext
              collisionDetection={dnd.collisionDetection}
              onDragEnd={dnd.handleDragEnd}
              sensors={dnd.sensors}
            >
              <CompanyProjectsTableContent
                rowSelection={rowSelection}
                rowsById={rowsById}
                table={table}
              >
                <CompanyProjectsTableBody
                  canCreateProjects={canCreateProjects}
                  childrenByFolderId={childrenByFolderId}
                  folderChildrenStateById={folderChildrenStateById}
                  formatMessage={formatMessage}
                  isError={isError}
                  movingItemIds={dnd.movingItemIds}
                  onCreateProject={handleOpenCreateProjectModal}
                  rowSelection={rowSelection}
                  rowsById={rowsById}
                  table={table}
                  search={search}
                />
              </CompanyProjectsTableContent>
            </DndContext>
          </ProjectMenuTableScrollContainer>
        </TableComponent.Root>
      </ProjectMenuTableContainer>

      <CompanyProjectsTablePagination
        pagination={pagination}
        rowSelection={rowSelection}
      />
    </TableProjectsContainer>
  )
}

export default CompanyProjectsList
